import React from 'react';

function Footer() {
return (
<>
   
      <footer className="footer">
        Created by <span>2050 Dashboards LLC web development team</span> | All rights reserved
      </footer>
    
</>

);

}

export default Footer;